import React from 'react'
import { SignIn, SignUp } from '@clerk/react'

import LoginImage from '@/public/images/loginImage.png'

/**
 * Enum-like constant defining the available authentication modes.
 * Use this instead of raw string literals when passing the `mode` prop.
 */
export const AuthMode = {
  SIGN_IN: 'SIGN_IN',
  SIGN_UP: 'SIGN_UP',
} as const

export type TAuthMode = (typeof AuthMode)[keyof typeof AuthMode]

type AuthPageProps = {
  mode: TAuthMode
}

/**
 * AuthPage Component
 *
 * Shared two-column authentication page used by both LoginPage and SignUpPage.
 * Accepts a `mode` prop (via the `AuthMode` constant) to toggle between
 * sign-in and sign-up.
 *
 * Key structural notes:
 * - Left column: uses `gridAutoRows: '1fr'` so the implicit grid row expands
 *   to fill the full container height, enabling `place-items-center` to work.
 * - Right column: decorative full-height background image (hidden on mobile)
 *
 * @param mode - `AuthMode.SIGN_IN` renders SignIn; `AuthMode.SIGN_UP` renders SignUp.
 */
const AuthPage: React.FC<AuthPageProps> = ({ mode }) => {
  return (
    <div className="flex h-screen overflow-hidden">
      <div className="grid flex-1 my-auto  justify-center">
        <div className="w-full max-w-sm">
          {mode === AuthMode.SIGN_IN ? (
            <SignIn routing="hash" />
          ) : (
            <SignUp routing="hash" />
          )}
        </div>
      </div>
      <div
        className="flex-1 hidden bg-no-repeat md:block"
        style={{
          backgroundImage: `url(${LoginImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />
    </div>
  )
}

export default AuthPage
